import React from 'react';
import { DefaultDivider } from 'services/UIUtils';
import Icon from 'components/Utils/NewIcon';
import './style.scss';

const GenericTopBar = ({ title, date, user }) => {
  return (
    <div className="generic-top-bar">
      <div className="content">
        <span className="large-title">{title}</span>
        {date !== undefined && (
          <div className="info">
            <Icon src="calendar-days" height="20px" />
            <span>{date}</span>
          </div>
        )}
        {user !== undefined && (
          <div className="info">
            <Icon src="user" height="20px" />
            <span>{user}</span>
          </div>
        )}
      </div>
      <DefaultDivider />
    </div>
  );
};

export default GenericTopBar;
